
import List from "./components/List.vue";
import {
  buildBreadcrumbJsonLd,
  buildPageJsonLd,
  flatTreeData,
  findParentElements,
  getBreadList,
  getSiteOrigin,
} from "~/utils/index.js";
export default {
  data() {
    return {
      pageSize: 12,
      currentPage: 1,
    };
  },
  asyncData({ app, route, store }) {
    const db = app.$websiteDataHelper;
    const pageBannerbg =
      encodeURI(db.getMenuItemBanner("products")) ||
      "/img/knowledge-page-banner.png";
    const routeId = route.meta[0].nodeid;
    const currentPage = route.meta[0].page || 1;
    const pageSize = 12;
    const { list, count } = db.getList(
      "products",
      routeId,
      currentPage,
      pageSize,
    );
    const productMenu = store.state.menu.filter(e => e.type === "products");
    const categories = app.$websiteDataHelper
      .getCategories("products", routeId)
      .sort((a, b) => a.sort * 1 - b.sort * 1);
    const hotProducts = db.hotProducts.slice(0, 3);

    const flatArray = flatTreeData(productMenu);
    const breadList = findParentElements(route.meta[0].nodeid, flatArray);

    const path = `/${route.path.split("/")[1]}`;
    const currentVO = app.$websiteDataHelper.getCurrentVO(productMenu, path);
    return {
      banner: pageBannerbg,
      title: (route?.meta[0]?.name || "products")
        .toUpperCase()
        .replace(/-/g, " "),
      menu: categories,
      list,
      textList: app.$websiteDataHelper.getProductClassYypeDes(),
      totalDataNumbers: count || 0,
      hotProducts,
      currentPage,
      customList: breadList,
      currentVO,
    };
  },
  head() {
    const { meta } = this.$route;
    const { menu, baseInfo, footerData } = this.$store.state;
    const siteUrl = getSiteOrigin();
    const breadList = getBreadList(menu, this.currentVO, 1);

    return {
      script: [
        {
          type: "application/ld+json",
          json: [
            buildPageJsonLd({
              route: this.$route,
              meta,
              siteUrl,
              baseInfo,
              footerData,
              includePublisher: true,
            }),
            buildBreadcrumbJsonLd(breadList),
          ],
        },
      ],
    };
  },
  components: { List },
};
